"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconTitle = void 0;
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const react_1 = __importDefault(require("react"));
const Text_1 = __importDefault(require("../Text"));
function IconTitle(props) {
    const { title, icon, style = {}, flip = false } = props;
    if (flip) {
        return (react_1.default.createElement(Horizontal_1.default, { shrink: true, justify: "flex-start", centered: true, gutter: true },
            !!title && (react_1.default.createElement(Pane_1.default, { grow: true },
                react_1.default.createElement(Text_1.default, { style: style }, title))),
            !!icon && react_1.default.createElement(Pane_1.default, null, icon)));
    }
    return (react_1.default.createElement(Horizontal_1.default, { shrink: true, justify: "flex-start", centered: true, gutter: true },
        !!icon && react_1.default.createElement(Pane_1.default, null, icon),
        !!title && (react_1.default.createElement(Pane_1.default, { grow: true },
            react_1.default.createElement(Text_1.default, { style: style }, title)))));
}
exports.IconTitle = IconTitle;
exports.default = IconTitle;
